import PurchaseDetail from "./PurchaseDetail";

export default PurchaseDetail;
